import clsx from 'clsx';
import pillStyles from '../../../../../shared/ui/pill/Pill.module.css';
import { OverflowPills } from '../../../../../shared/ui/overflow-pills';
import { EllipsizedText } from '../../../../../shared/ui/ellipsized-text';
import { TemplateIdLabel } from '../../template-id-label/TemplateIdLabel';
import styles from '../TemplateCard.module.css';

const TITLE_MAX_HEIGHT_PX = 48;

export function TemplateCardBody({ templateId = null, title, tags }) {
  return (
    <div className={clsx(styles.body)}>
      <div className={clsx(styles.titleGroup)}>
        <TemplateIdLabel templateId={templateId} />

        <EllipsizedText
          as="h3"
          className={styles.title}
          triggerClassName={styles.titleTrigger}
          truncatedClassName={styles.titleTriggerActive}
          maxHeightPx={TITLE_MAX_HEIGHT_PX}
          tooltipContent={<span className={styles.titleTooltipText}>{title}</span>}
        >
          {title}
        </EllipsizedText>
      </div>

      <OverflowPills
        items={tags}
        className={clsx(styles.tags)}
        pillClassName={pillStyles.pill}
        ariaLabel="Tags"
        tooltipItemTransform={(value) => value.toUpperCase()}
      />
    </div>
  );
}
